import { render, staticRenderFns } from "./CutSummaryCatching.vue?vue&type=template&id=58287c88"
import script from "./CutSummaryCatching.vue?vue&type=script&lang=js"
export * from "./CutSummaryCatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports